import { createLocationConstants } from '..'

export const routerConstants = {
  ...createLocationConstants(
    {
      /** 診断開始 */
      QUESTIONS_INDEX: '/questions',
      /** Q1 */
      QUESTIONS_ONE: '/questions/q1',
      /** Q2 */
      QUESTIONS_TWO: '/questions/q2',
      /** Q3 */
      QUESTIONS_THREE: '/questions/q3',
      /** Q4 */
      QUESTIONS_FOUR: '/questions/q4',
      /** Q5 */
      QUESTIONS_FIVE: '/questions/q5',
      /** 診断結果 */
      QUESTIONS_RESULT: '/questions/result',
    },
    {
      /** 診断開始 */
      QUESTIONS_INDEX: 'index',
      /** Q1 */
      QUESTIONS_ONE: 'q1',
      /** Q2 */
      QUESTIONS_TWO: 'q2',
      /** Q3 */
      QUESTIONS_THREE: 'q3',
      /** Q4 */
      QUESTIONS_FOUR: 'q4',
      /** Q5 */
      QUESTIONS_FIVE: 'q5',
      /** 診断結果 */
      QUESTIONS_RESULT: 'result',
    }
  ),
}
